"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 18.01.2019
*/

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Represents types for distribution model - used in Promo - WindowItem class.
 *
 * @author ZSr
 */


var PromoDistributionModel =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(PromoDistributionModel, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param description
   * @param flags
   * @param externalId - used for export
   * @param classification
   */
  function PromoDistributionModel(id, title) {
    var _this;

    var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : immutable_1.List();
    var externalId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var classification = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, PromoDistributionModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoDistributionModel).call(this, id, title, description, flags, externalId));
    _this.id = id;
    _this.title = title;
    _this.description = description;
    _this.flags = flags;
    _this.externalId = externalId;
    _this.classification = classification;
    return _this;
  }

  return PromoDistributionModel;
}(CodebookItem_1.CodebookItem);

exports.PromoDistributionModel = PromoDistributionModel;
/** External id of Distribution Model called Days to Cover */

PromoDistributionModel.DAYS_TO_COVER_EXT_ID = '9';
/** Name of code book for generic code book API. */

PromoDistributionModel.CODEBOOK_NAME = 'distribution-model';

PromoDistributionModel.distSchema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoDistributionModel.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    description: builder.opt(builder.str('description')),
    flags: builder.listOf(builder.str('flags')),
    externalId: builder.opt(builder.str('externalId')),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: PromoDistributionModel.name + '_classification'
    }))
  };
}();